const heroCarouselImages=[
  'guide-carousel-01','guide-carousel-02','guide-carousel-03','guide-carousel-04',
  'guide-carousel-05','guide-carousel-06','guide-carousel-07','guide-carousel-08',
];

export default function HeroFootballCanvas({ priority=true }) {
  return <div className="hero-football-art hero-circle-carousel" aria-hidden="true">
    <div className="hero-circle-track">
      {heroCarouselImages.map((image,index)=><figure key={image} style={{'--carousel-angle':`${index*45}deg`}}>
        <picture>
          <source media="(max-width:760px)" srcSet={`/assets/${image}-mobile.webp`}/>
          <img src={`/assets/${image}-desktop.webp`} alt="" width="640" height="640" loading={!index&&priority?'eager':'lazy'} fetchPriority={!index&&priority?'high':'auto'} decoding="async"/>
        </picture>
      </figure>)}
    </div>
  </div>;
}

export function HeroPhotoCollage() {
  return <div className="hero-football-art seo-photo-collage hero-photo-collage" aria-hidden="true">
    {[1,2].map(number=><picture className={`seo-collage-card seo-collage-card-${number}`} key={number}>
      <source media="(max-width:760px)" srcSet={`/assets/thai-collage-0${number}-mobile.webp`}/>
      <img src={`/assets/thai-collage-0${number}-desktop.webp`} alt="" width="700" height="700" loading={number===1?'eager':'lazy'} fetchPriority={number===1?'high':'auto'} decoding="async"/>
    </picture>)}
  </div>;
}
